import { ReactNode } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { isPoolAdmin } from '../utils/roles'

interface PoolAdminRouteProps {
  children: ReactNode
}

export default function PoolAdminRoute({ children }: PoolAdminRouteProps) {
  const { user } = useAuth0()

  if (!isPoolAdmin(user)) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 dark:bg-red-900">
            <svg className="h-6 w-6 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="mt-4 text-2xl font-bold text-gray-900 dark:text-white">Pool Administrator Access Required</h1>
          <p className="mt-2 text-gray-600 dark:text-gray-300">
            You need Pool Administrator privileges to access this page.
          </p>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Pool Administrators can create and manage football pools, select games, and update results.
          </p>
          <div className="mt-6">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}